import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeadlessPageComponent} from './pages/headless-page/headless-page.component';
import {CommunicationCommonModule} from '../communication-common/communication-common.module';



@NgModule({
    declarations: [
        HeadlessPageComponent
    ],
    exports: [
        HeadlessPageComponent
    ],
  imports: [
    CommonModule,
    CommunicationCommonModule,
  ]
})
export class HeadlessModule { }
